import React from "react";
import type { Project } from "../../api/useProjects";
import ActivityGroup from "./ActivityGroup";
import type { Activity } from "../../api/useActivities";

interface Props {
  activities: Activity[];
  timeZone: string | null;
  embeded: boolean;
  projectsIndex: { [id: string]: Project };
}

export const ActivityComponent = ({ activities, timeZone, embeded, projectsIndex }: Props) => {
  const activitiesDateIndex = React.useMemo(
    () =>
      activities.reduce<{ [key: string]: Activity[] }>((acc, currentValue) => {
        const date = new Date(currentValue.updatedAt);
        const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        if (acc[key]) {
          acc[key].push(currentValue);
        } else {
          acc[key] = [currentValue];
        }
        return acc;
      }, {}),
    [activities],
  );

  return (
    <>
      {Object.entries(activitiesDateIndex).map(([date, activities]) => (
        <ActivityGroup
          key={date}
          activities={activities}
          timeZone={timeZone}
          embeded={embeded}
          projectsIndex={projectsIndex}
        />
      ))}
    </>
  );
};

export default React.memo(ActivityComponent);
